var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "37px",
    height: "36px",
    viewBox: "0 0 37 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4050B9EF-8BA5-4748-A5CF-4897A1A8BA5F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-Successful",
    transform: "translate(-41.000000, -298.000000)",
    fill: "#FBC044"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    points: "59.5 328.784773 48.0381876 333.275831 48.7675435 320.987187 40.9543979 311.474169 52.8669771 308.370427 59.5 298 66.1330229 308.370427 78.0456021 311.474169 70.2324565 320.987187 70.9618124 333.275831"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9c69b8b800268742b74da7eddb5d5422.svg";
export { ForwardRef as ReactComponent };